import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';

export default {
    name: 'educationMyTest',

    data() {
        return {
            quiz: {},
        };
    },

    components: {
        BaseLayout
    },

    methods: {
        /**
         * Gets the education quiz from API
         */
        getMyTestResult() {
            api.get(`/api/get_my_promotion_education_quiz/${this.$route.params.id}`)
                .then((response) => {
                    this.quiz = response.data.body.entry;
                });
        }
    },

    mounted() {
        this.getMyTestResult();
    },
}
